// ABOUTME: Pill toggle that picks a BI report's subtype — what a row counts: the entity, its lines, or the summed line amounts.
// ABOUTME: Renders nothing for reports whose config offers no subtypes; styled identically to the pivot header's Bereik/Kolom pill.
import { ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import { reportSubtypeKeys } from "../chartOptions";
import { getReportSubtypes } from "../reports";
import { useReportHubFilters } from "../ReportHubFilterContext";

export const RhSubtypeToggle = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const filtersRegistry = useReportHubFilters();

    const subtypes = getReportSubtypes(props.currentReport, filtersRegistry.environment);

    if (subtypes.length === 0) {
        return null;
    }

    const background = props.background ?? colors.grey[200];

    return (
        <ToggleButtonGroup
            value={props.currentReport?.subtype ?? reportSubtypeKeys.BASE}
            exclusive
            disabled={props.disabled}
            onChange={(e, newSubtype) => {
                if (!newSubtype) return;

                props.setCurrentReport(prev => ({
                    ...prev,
                    subtype: newSubtype,
                }));
            }}
            aria-label="Subtype"
            sx={{
                background:background,
                padding:0.5,
                borderRadius:5,
                transition:"250ms",
                ...props.sx,
            }}
        >
            {subtypes.map((subtype) => (
                <ToggleButton
                    key={subtype.key}
                    value={subtype.key}
                    sx={{
                        flex:1,
                        padding: 0,
                        paddingX: 2,
                        border: 0,
                        lineHeight: "32px",
                        textTransform: "unset",
                        borderRadius: "32px !important",
                        color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400],
                        transition: "250ms",
                        "&.Mui-selected": {
                            background: colors.grey[400],
                            color: "#fff",
                            fontWeight:"bold",
                        },
                        "&.Mui-selected:hover": {
                            background:theme.palette.mode === "dark" ? colors.grey[600]: "#1F293D",
                        },
                    }}
                >
                    <span
                        style={{
                            flexShrink:0,
                        }}
                    >
                        {t(subtype.labelKey)}
                    </span>
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};
